/* src/app/core/footer/footer.component.scss */
/*# sourceMappingURL=footer.component.css.map */
